import {
  PagedResponseEmpty,
  ValidationError,
} from "@ofqual/portal-core/core/types";
import { combineReducers, AnyAction } from "redux";
import {
  LOADED_ITEMS,
  LOADING_ITEMS,
  INPUTTING_ITEM,
  CREATED_ITEM,
  CREATING_ITEM,
  CREATING_ITEM_VALIDATION_FAIL,
  LOADED_ITEM,
  LOADING_ITEM,
  SAVED_ITEM,
  UPDATING_ITEM,
  SEND_MESSAGE_ERROR,
  CLEAR_ERROR,
} from "./actions";
import { CreateItemState, ItemsState, ItemState } from "./state";
import { failedCrudResult, noCrudResult, successCrudResult } from "./types";

const itemInitialState: ItemState = {
  status: "NOT_LOADED",
  item: null,
  lastCrudResult: noCrudResult(),
  error: null,
};

const itemsInitialState: ItemsState = {
  status: "NOT_LOADED",
  response: PagedResponseEmpty,
  hasData: false,
};

const items = (
  state: ItemsState = itemsInitialState,
  action: AnyAction
): ItemsState => {
  const { type, payload } = action;
  switch (type) {
    case LOADING_ITEMS:
      return {
        ...state,
        status: "LOADING",
      };
    case LOADED_ITEMS:
      return {
        ...state,
        status: "LOADED",
        response: payload,
        hasData: true,
      };
    default:
      return state;
  }
};

const item = (
  state: ItemState = itemInitialState,
  action: AnyAction
): ItemState => {
  const { type, payload } = action;
  switch (type) {
    case LOADING_ITEM:
      return {
        ...state,
        item: null,
        status: "LOADING",
        lastCrudResult: noCrudResult(),
      };
    case UPDATING_ITEM:
      return {
        ...state,
        status: "UPDATING",
        lastCrudResult: noCrudResult(),
      };
    case LOADED_ITEM:
      return {
        ...state,
        status: "LOADED",
        item: payload,
      };
    case SAVED_ITEM:
      return {
        ...state,
        status: "LOADED",
        item: payload,
        lastCrudResult: successCrudResult(),
      };
    case SEND_MESSAGE_ERROR:
      return {
        ...state,
        error:
          payload.message || "Something went wrong, please try again later",
      };
    case CLEAR_ERROR:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

const createItemInitialState: CreateItemState = {
  status: "INPUTTING",
  lastCrudResult: noCrudResult(),
};
const createItem = (
  state: CreateItemState = createItemInitialState,
  action: AnyAction
): CreateItemState => {
  const { type, payload } = action;
  if (type === CREATING_ITEM) {
    return {
      ...state,
      status: "CREATING",
    };
  }
  if (type === CREATING_ITEM_VALIDATION_FAIL) {
    return {
      ...state,
      lastCrudResult: failedCrudResult(payload as ValidationError),
      status: "INPUTTING",
    };
  }
  if (type === CREATED_ITEM) {
    return {
      ...state,
      lastCrudResult: noCrudResult(),
      status: "CREATED",
    };
  }
  if (type === INPUTTING_ITEM) {
    return {
      ...state,
      lastCrudResult: noCrudResult(),
      status: "INPUTTING",
    };
  }
  return state;
};

export const rootReducer = combineReducers({
  items,
  item,
  createItem,
});
